export default "__VITE_ASSET__BJYAJCPP__"